import { Locale } from 'modules/i18n';

export const averageRequestsCardTranslation = {
  [Locale.en]: {
    title: 'Average Req/Sec',
  },
};
